<template>
  <div class="significance_add">
    <el-form :inline="true" class="demo-form-inline">
      <h2 style="width: 100%;height: 60px;text-align: center;line-height: 60px;">分析数据源设置</h2>

      <el-form-item label="分析标题" style="width: 30%;margin-left:20px">
        <el-input v-model="analysisTitle" placeholder="分析标题"></el-input>
      </el-form-item>

      <el-form-item label="量表名称" style="width: 30%;">
        <el-input placeholder="量表名称" v-model="papername" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item label="发布主题" style="width: 30%;">
        <el-select v-model="publishID" placeholder="发布主题">
          <el-option v-for="item in value7" :key="item.PublishID" :label="item.PublishSubject" :value="item.PublishID"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="分析对象" style="width: 30%;margin-left:20px">
        <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptID" filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable ></el-cascader>
      </el-form-item>

      <el-form-item label="开始时间" style="width: 30%;">
        <el-date-picker v-model="startDate"  type="date" placeholder="选择日期" value-format="yyyy-MM-dd"  format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间" style="width: 30%;">
        <el-date-picker v-model="endDate"  type="date" placeholder="选择日期" value-format="yyyy-MM-dd"  format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>

      <h2 style="width: 100%;height: 60px;text-align: center;line-height: 60px;">分析结果设置（至少配置一组Z检验/T检验/F检验参数）</h2>

      <el-form-item label="Z检验比较维度" style="width: 30%;margin-left:20px">
        <el-select v-model="zcompareObject" placeholder="发布主题">
          <el-option v-for="item in nddata" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="T检验比较维度" style="width: 30%;">
        <el-select v-model="tcompareObject" placeholder="发布主题">
          <el-option v-for="item in nddata" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="F检验比较维度" style="width: 30%;">
        <el-select v-model="fcompareObject" placeholder="发布主题">
          <el-option v-for="item in nddata" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="Z检验统计分数" style="width: 30%;margin-left:20px">
        <el-select v-model="zcomputeScore" placeholder="请选择">
          <el-option-group v-for="group in fsdata" :key="group.val" :label="group.val">
            <el-option v-for="item in group.children" :key="item.val" :label="item.val" :value="item.val">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-form-item label="T检验统计分数" style="width: 30%;">
        <el-select v-model="tcomputeScore" placeholder="请选择">
          <el-option-group v-for="group in fsdata" :key="group.val" :label="group.val">
            <el-option v-for="item in group.children" :key="item.val" :label="item.val" :value="item.val">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-form-item label="F检验统计分数" style="width: 30%;">
        <el-select v-model="fcomputeScore" placeholder="请选择">
          <el-option-group v-for="group in fsdata" :key="group.val" :label="group.val">
            <el-option v-for="item in group.children" :key="item.val" :label="item.val" :value="item.val">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-form-item label="是否启用" style="width: 30%;margin-left:20px">
        <el-radio-group v-model="isActive">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <div style="width: 100%;text-align: center;" >
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </div>


    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" >
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>
  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
export default {
  data() {
    return {
      analysisTitle: '',
      paperID: '',
      publishID: '',
      DeptID: '',
      startDate: '',
      endDate: '',
      zcompareObject: '',
      zcomputeScore: '',
      tcompareObject: '',
      tcomputeScore: '',
      fcompareObject: '',
      fcomputeScore: '',
      isActive: '',






      dialogVisible:false,
      papername: '',
      optionsnew:[],
      
      nddata:[],
      fsdata:[],
      value7:[],
    }
  },
  beforeCreate() {

  },
  components:{
    scales_Pop
  },
  methods: {
    onSubmit() {

      if([this.$route.query.paperID][0]){
        this.$Http_Post('/paper/analysis/edit', {
          analysisTitle:  this.analysisTitle,
          paperID:        this.paperID,
          publishID:      this.publishID,
          deptID:         this.DeptID,
          startDate:      this.startDate,
          endDate:        this.endDate,
          zcompareObject: this.zcompareObject,
          zcomputeScore:  this.zcomputeScore,
          tcompareObject: this.tcompareObject,
          tcomputeScore:  this.tcomputeScore,
          fcompareObject: this.fcompareObject,
          fcomputeScore:  this.fcomputeScore,
          isActive:       this.isActive,
          analysisKey:    [this.$route.query.analysisKey][0]
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            this.Global.request_successful(res.Message);
            this.$router.push({
              path: '/Measurement/significance',
            })
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      }else{
        this.$Http_Post('/paper/analysis/add', {
          analysisTitle:  this.analysisTitle,
          paperID:        this.paperID,
          publishID:      this.publishID,
          deptID:         this.DeptID,
          startDate:      this.startDate,
          endDate:        this.endDate,
          zcompareObject: this.zcompareObject,
          zcomputeScore:  this.zcomputeScore,
          tcompareObject: this.tcompareObject,
          tcomputeScore:  this.tcomputeScore,
          fcompareObject: this.fcompareObject,
          fcomputeScore:  this.fcomputeScore,
          isActive:       this.isActive,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            this.Global.request_successful(res.Message);
            this.$router.push({
              path: '/Measurement/significance',
            })
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    getmsg(val){//量表点击时子组件传过来值
      this.papername = val.label;
      this.paperID = val.val;
      this.csu(this.paperID);
    },
    csu(val){
      this.$Http_Post('/paperconfig/factor/getscorelist', {paperCode: val}).then((res) => {
        if (res.Data) {
          this.fsdata = res.Data;
        }
      });
    },
    cel(){
      this.dialogVisible = true;
    },
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.analysisKey(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {

      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children
          );
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 &&  obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: dt[dt.length - 1],content: ''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }

    },
  },
  mounted() {
    if([this.$route.query.paperID][0]){
      this.csu([this.$route.query.paperID][0])
      this.$Http_Post('paper/analysis/getinfo', {analysisKey:[this.$route.query.analysisKey][0]}).then((res) => {
        if (res.Code == 200 || res.Code == 0 ) {
          this.analysisTitle = res.Data.analysisTitle
          this.paperID= res.Data.paperID
          this.publishID= res.Data.publishID
          this.DeptID= res.Data.deptID
          this.startDate= res.Data.startDate
          this.endDate= res.Data.endDate
          this.zcompareObject= res.Data.zcompareObject
          this.zcomputeScore= res.Data.zcomputeScore
          this.tcompareObject= res.Data.tcompareObjectimage.png
          this.tcomputeScore= res.Data.tcomputeScore
          this.fcompareObject= res.Data.fcompareObject
          this.fcomputeScore= res.Data.fcomputeScore
          this.isActive= res.Data.isActive.toString()
        }
      });
    }
  },
  created() {
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: '',content: '',}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.optionsnew = res.Data;
      }
    });

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 52 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.nddata = res.Data;
      }
    })

    this.$Http_Post('EmphasisClarification/GetSubjectPublish', { }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value7 = res.Data;
      }
    })

  },
}
</script>
<style>
.significance_add {width: 100%;height: 100%;background-color: #fff;}
.significance_add .demo-form-inline{width: 100%;background-color: #fff;}
</style>
